<template lang="pug">
  div(class="block-route-details")
    h2(class="title-32px fw-700 mb-2") {{ $t('Route details') }}
    div(class="text-14px fw-300 mb-6") {{ $t('Created at {date}', { date: routeMeta.createdAt }) }}
    div(class="block-route-details__name-block")
      div(class="text-12px fw-300 mb-1") {{ $t('Route name') }}
      div(class="text-14px dark") {{ route.name }}
    div(class="members")
      div(class="text-12px fw-300") {{ $t('Recipients') }}
      div(
        v-for="(member, idx) in route.members"
        :key="idx"
        class="member"
      )
        div(class="member__left")
          div(class="text-14px dark fw-300") {{ idx + 1 }}
          div
            div(class="text-14px dark fw-300") {{ member.identifier }}
        div(class="member__right")
          span(class="text-14px dark") {{ mapParticipantActionToText[member.action] }}
    div(
      v-if="!route.strict"
      class="not-strict"
    )
      e-svg-icon check-circle-black
      div(class="text-14px dark fw-300") {{ $t('Document will be approved after first approve') }}
    div(class="block-route-details__footer")
      v-btn(
        height="48"
        @click="editRoute"
      ) {{ $t('Edit') }}
      v-btn(
        class="main-button"
        @click="useRoute"
      ) {{ $t('Use') }}
</template>

<script>
import participants from '~/modules/documents/mixins/participants'
import contentDialog from '~/mixins/dialogs/contentDialog'

export default {
  name: 'BlockRouteDetails',
  mixins: [participants, contentDialog],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    route: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    routeMeta() {
      const createdAt = this.$moment(this._.get(this.route, 'createdAt')).format('DD MMMM YYYY')
      return {
        createdAt
      }
    }
  },
  methods: {
    useRoute() {
      this.closeModal()
      this.$router.push({ name: 'documents-create', query: { routeId: this.route.id } })
    },
    editRoute() {
      this.contentDialog.open({
        width: '724px',
        removePadding: true,
        component: 'm-document-saved-participants-route-form',
        componentProps: {
          route: this.route
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.block-route-details {
  &__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    padding-top: 24px;
    margin-top: 16px;
    border-top: 1px solid $border-disabled;
  }
  &__name-block {
    border-radius: 12px;
    background: $background-gray;
    padding: 12px 16px;
    margin-bottom: 16px;
  }
}

.members {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 12px;
  background: $background-gray;
  padding: 12px 16px;
}

.member {
  display: flex;
  align-items: center;
  justify-content: space-between;
  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}
.not-strict {
  display: flex;
  align-items: center;
  gap: 8px;

  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 12px;
  background: $background-gray;
}
</style>
